module.exports = __webpack_public_path__ + "img/new1.c04f5803.png";